import { useMemo, useState, useCallback } from "react";

import {
  Box,
  HStack,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Heading,
  Stack,
  VStack,
  CircularProgress,
  Text,
  useDisclosure,
} from "@chakra-ui/react";

import { useHistory } from "react-router-dom";

// import Arrow from "assets/svg/icons-new/arrow.svg";

import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
// import Button from "components/Button/Button";
// import Select from "components/Select/Select";
// import Input from "components/Input/Input";
// import SuccessModal from "components/Modals/Success";
import FilterModal from "components/Modals/PartnersFilter";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import Paginator from "components/Paginator/Paginator";
import HistoryItem from "components/AffiliateItems/HistoryItem";

import { ReactComponent as FilterIcon } from "assets/svg/filter.svg";
import Button from "components/Button/Button";

import { useGetAffiliateEarningsQuery } from "services/walletApi";

import isEmpty from "lodash/isEmpty";

// import {}

// import constant from "config/constant";
// import toPrecision from "util/toPrecision";
// import toCoinLocale from "util/toCoinLocale";
import { toQueryString } from "util/utils";
import toPrecision from "util/toPrecision";

export default function RewardHistoryEarnings(props) {
  //   const { userData } = props;

  //   const { id } = useParams();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [state, _setState] = useState({
    page: 1,
    limit: 10,
    // ...filters,
  });

  const queries = useMemo(() => toQueryString(state), [state]);

  const setState = useCallback(
    (newState) => _setState(() => ({ ...state, ...newState })),
    [state]
  );

  const { data, isLoading } = useGetAffiliateEarningsQuery(queries);
  const earnings = useMemo(() => data?.earnings, [data]);
  const totalCount = useMemo(() => data?.totalCount, [data]);

  //   const toast = useToast();
  //   const loaded = useRef(false);
  const history = useHistory();
  // const { isOpen, onOpen, onClose } = useDisclosure();
  //   const [state, _setState] = useState({ type: "price" });

  //   const setState = (newState) => _setState(() => ({ ...state, ...newState }));

  return (
    <Box>
      <Sidemenu currentPage="Account" logoutUser={props.logout} />
      <Header />
      <Box as="section">
        <Box
          className="account-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "100%", "calc(100% - 15vw)", "calc(100% - 30vw)"]}
            m="0"
            p={[0, 0, "1rem"]}
          >
            <Stack mx={["24px", 0]} mb={["24px", "32px"]}>
              <HStack w="100%" justifyContent="space-between">
                <Heading>Earnings</Heading>

                <Button onClick={onOpen}>
                  <HStack>
                    <Box boxSize="20px" as={FilterIcon} />
                    <Text>Filter</Text>
                  </HStack>
                </Button>
              </HStack>
              ;
              <Breadcrumb
                className="animate__animated animate__fadeInDown"
                separator={
                  <ArrowForwardIosRoundedIcon
                    style={{ fontSize: ".8em", color: "#6E7191" }}
                  />
                }
              >
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account">
                    Account
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account/partners">
                    Bitmama Partners
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account/partners/view?tab=reward">
                    Reward History
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage to="">
                    Earnings
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Stack>

            <Box
              bg="white"
              p={["32px 24px", "32px 24px", "40px 22px"]}
              //   mt={["24px", "10px"]}
              borderRadius={[0, "8px", "16px"]}
            >
              <Stack>
                {/* {Array(10)
                  .fill(0)
                  .map((_, i) => (
                    <HistoryItem
                      key={`earnings-${i}`}
                      to={`/dashboard/account/partners/earnings/${i + 1}`}
                    />
                  ))} */}

                <VStack>
                  {isLoading && (
                    <CircularProgress
                      disabled
                      isIndeterminate
                      color="#a7a7a7"
                      size="32px"
                    />
                  )}

                  {!isLoading && isEmpty(earnings) && (
                    <Text>History not found</Text>
                  )}
                </VStack>

                {earnings?.map((ref, i) => (
                  <HistoryItem
                    _for="earnings"
                    key={`invite-history-${i}`}
                    // to={`/dashboard/account/partners/invites/${ref?._id}`}
                    name={ref?.referredUserId?.fullName}
                    email={`${toPrecision(
                      ref?.value?.$numberDecimal,
                      ref?.unit,
                      true,
                      8,
                      true
                    )} ${ref?.description}`}
                    createdAt={ref?.createdAt}
                    onClick={() =>
                      history.push(
                        `/dashboard/account/partners/earnings/${ref?._id}`,
                        ref
                      )
                    }
                  />
                ))}

                {totalCount && (
                  <Paginator
                    page={state?.page}
                    limit={state?.limit}
                    totalCount={totalCount}
                    onNextPage={(next) => setState({ page: next })}
                  />
                )}
              </Stack>
            </Box>
          </Container>
        </Box>
      </Box>

      {/* <SuccessModal
        isOpen={isOpen}
        onClose={handleClose}
        title="Success"
        message={`Price alert successfully updated `}
      /> */}

      <FilterModal
        isOpen={isOpen}
        onClose={onClose}
        onFilter={(filter) => setState({ ...filter })}
      />
    </Box>
  );
}
